<template>
  <div class="explore">
    <div class="content">

      <scene-view-3-d :options="{ type: '3d', x: this.$route.params.x, y: this.$route.params.y }" v-if="$route.params.type === '3d'"/>

    </div>
  </div>
</template>

<script>
  import SceneView3D from '../components/scene/View3D'

  const SCENE_TYPES = ['3d']

  export default {
    name: 'Explore',

    components: { SceneView3D },

    mounted() {
      if (!SCENE_TYPES.includes(this.$route.params.type)) {
        this.$router.push('/not-found')
      }
    }
  }
</script>
